import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { DadoBancarioService } from 'src/app/services/dado-bancario.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { CedenteService } from 'src/app/services/cedente.service';
import { ParametrosDataService } from 'src/app/services/parametros-data.service';

import { Router, ActivatedRoute } from '@angular/router';
import { Auth } from 'src/app/models/auth';
import { CadastroPix, DadoBancarioCedenteCadastro } from 'src/app/models/dado-bancario-cedente-cadastro';
import { CedenteCnpjAlternativo } from 'src/app/models/cedente-cnpj-alternativo';
import { Banco } from 'src/app/models/banco';
import { ApiError } from 'src/app/shared/enums/api-error.enum';

import { GenericValidator } from 'src/app/shared/validators/generic-validator.validator';
import { Subscription } from 'rxjs';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { waitForAsync } from '@angular/core/testing';
import { PixResponse } from 'src/app/models/dado-bancario-cedente';

import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ChavePixService } from 'src/app/services/chave-pix.service';
import { SelectedTipoChave } from 'src/app/models/selected-chave-pix';


@Component({
    selector: 'app-dado-bancario-create',
    templateUrl: './dado-bancario-create.component.html',
    styleUrls: ['./dado-bancario-create.component.css']
})
export class DadoBancarioCreateComponent implements OnInit, OnDestroy {

    constructor(
        private formBuilder: FormBuilder,
        private dadoBancarioService: DadoBancarioService,
        private authenticationService: AuthenticationService,
        private alertService: NewAlertService,
        private cedenteService: CedenteService,
        private pixService: ChavePixService,
        private parametrosDataService: ParametrosDataService,
        private router: Router,
        private fb: FormBuilder,
        private route: ActivatedRoute
    ) {}

    public maskCnpjRaiz = [/[0-9]/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/];
    public maskCnpjComplemento =  [/[0-9]/, /\d/, /\d/, /\d/, '-', /\d/, /\d/];
    public formPix: FormGroup;
    private currentUser: Auth;
    public dadoBancarioCadastro: DadoBancarioCedenteCadastro;
    public cedenteCnpjAlternativo: CedenteCnpjAlternativo;
    public bancosList: Banco[];
    public cnpjError: boolean = false;
    /* wwwwwwww-wwww-wwww-wwww-wwwwwwwwwwww */
    public chaveAleMAsk = [/\w/,/\w/,/\w/,/\w/,/\w/,/\w/,/\w/,/\w/,'-',/\w/,/\w/,/\w/,/\w/,'-',/\w/,/\w/,/\w/,/\w/,'-',/\w/,/\w/,/\w/,/\w/,'-',/\w/,/\w/,/\w/,/\w/,/\w/,/\w/,/\w/,/\w/,/\w/,/\w/,/\w/,/\w/ ];
    public cpfMask = [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/];
    public cnpjMask = [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/];
    public celularMask = ['(',/\d/, /\d/, ')', /\d/, /\d/, /\d/, /\d/, /\d/, '-' ,/\d/, /\d/, /\d/, /\d/];
    public complementoMask = [/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/];
    public cadastroForm: CadastroPix;
    public tipoChavePix: number;
    public tipoChavePixDesc: string;
    public typesPix: Array<PixResponse>;
    selectedItems: SelectedTipoChave;

    private routeSubscription: Subscription;
    private urlReturn = null;

    public dadoBancarioFormGroup: FormGroup;
    dropdownList = [];
    dropdownSettings: IDropdownSettings = {};



    public get form() {
        return this.dadoBancarioFormGroup.controls;
    }

    ngOnInit() {
        this.routeSubscription = this.route.queryParamMap.subscribe(params => {
            if (params != null) {
                this.urlReturn = params.get('urlReturn');
            }
        });

        this.dropdownSettings = {
            singleSelection: true,
            idField: 'id',
            textField: 'nome',
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            itemsShowLimit: 1,
            allowSearchFilter: true,
            closeDropDownOnSelection: true
          };
          this.pixService.getTipoChavePix('j').subscribe(res => {
            if (res.status === 1) {

              this.typesPix = res.result;
              this.dropdownList = this.typesPix.map(element =>{
                return{
                  id: element.keyType,
                  nome: element.description
                }
              })
            }
          });

          /* this.bancoService.getBancos(this.dashData.result.estabelecimento.contaIdWallet).subscribe(res => {
            if (res.status === 1) {
              this.bancos = res.result;
              this.dropdownList = this.bancos.map(element => {
                return {
                  id: element.id,
                  nome: element.codigo + ' - ' + element.nome
                };
              });
            }
          }); */

          this.criarFormularioDadosBancarios();

        this.currentUser = this.authenticationService.currentUserValue;
        // usar para criar / editar
        // validar se foi para esse componente com o id do centro de custo (sim = editar) (não = cadastrar)
        /* this.dadoBancarioService.getAllBancos().subscribe(
            response => {
                if (response.status === ApiError.Sucesso) {
                    this.bancosList = response.result;
                    for (const b of this.bancosList) {
                        if (b.preferencial) {
                            b.preferencialSymbol = '*preferencial';
                        }
                    }

                    this.bancosList = this.bancosList.sort((a, b) => a.codigo.localeCompare(b.codigo));
                } else {
                    this.alertService.error(response.message);
                }
            }
        );

        this.dadoBancarioCadastro = new DadoBancarioCedenteCadastro(null, '', '', '', '', false, false, '');
        this.cedenteCnpjAlternativo = new CedenteCnpjAlternativo(false, '', '');
        this.createForm(this.dadoBancarioCadastro, this.cedenteCnpjAlternativo);

        this.cedenteService.getInfo(this.currentUser.token.assignorGuid, this.currentUser.token.userReferenceId).subscribe(
            async response => {
                let cnpj = ("00000000000000" + response.result.cedente.cnpj
                    .toString())
                    .slice(-14)
                    .substring(0,8);
                this.dadoBancarioFormGroup.controls.cnpjRaiz.setValue(cnpj);

            },
            error => {
                console.log("erro ao buscar cnpj")
            }
        ); */

    }
    criarFormularioDadosBancarios() {
        this.formPix = this.fb.group({
          tipoChave: ['', Validators.required],
          chave: ['', Validators.required],
        });
      }

    ngOnDestroy() {
        this.routeSubscription.unsubscribe();
    }

    validarCNPJ(cnpj: any) {
        cnpj = cnpj.replace(/[^\d]+/g,'');

        if(cnpj == '') return false;

        if (cnpj.length != 14)
            return false;

        let tamanho = cnpj.length - 2
        let numeros = cnpj.substring(0,tamanho);
        let digitos = cnpj.substring(tamanho);
        let soma = 0;
        let pos = tamanho - 7;

        for (let i = tamanho; i >= 1; i--) {
          soma += numeros.charAt(tamanho - i) * pos--;
          if (pos < 2)
                pos = 9;
        }
        let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
        if (resultado != digitos.charAt(0))
            return false;

        tamanho = tamanho + 1;
        numeros = cnpj.substring(0,tamanho);
        soma = 0;
        pos = tamanho - 7;
        for (let i = tamanho; i >= 1; i--) {
          soma += numeros.charAt(tamanho - i) * pos--;
          if (pos < 2)
                pos = 9;
        }
        resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
        if (resultado != digitos.charAt(1))
              return false;

        return true;
    }

    enviarDados() {
        let cadastroCNPJ = '';

        this.cadastroForm = {
          pessoaId: this.currentUser.token.pessoaId,
          chave: this.formPix.get('chave').value,
          tipoChave: this.tipoChavePix
        };

        if(this.tipoChavePix == 1 ||this.tipoChavePix == 2 || this.tipoChavePix == 3 )
          this.cadastroForm.chave = this.cadastroForm.chave.replace(/[^\d]+/g,'');

        this.pixService.postChavePix(this.cadastroForm.pessoaId, this.cadastroForm.chave, this.cadastroForm.tipoChave).subscribe(res =>{
          if(res.status == 1){
            this.alertService.success('Chave Pix registrada com sucesso!');

            this.router.navigate(['/portal/dadobancario/list']);

          }else{
            this.alertService.error(res.message);
          }

        });


      }



    createForm(dadoBancarioCadastro: DadoBancarioCedenteCadastro, cedenteCnpjAlternativo: CedenteCnpjAlternativo) {
        this.dadoBancarioFormGroup = this.formBuilder.group({
            bancoId: new FormControl(dadoBancarioCadastro.bancoId, [
                Validators.required
            ]),
            bancoPreferencial: new FormControl(dadoBancarioCadastro.bancoPreferencial),
            agencia: new FormControl(dadoBancarioCadastro.agencia, [
                Validators.required,
                Validators.maxLength(10)
            ]),
            digitoAgencia: new FormControl(dadoBancarioCadastro.digitoAgencia, [
                Validators.maxLength(2)
            ]),
            conta: new FormControl(dadoBancarioCadastro.conta, [
                Validators.required,
                Validators.maxLength(15)
            ]),
            digitoConta: new FormControl(dadoBancarioCadastro.digitoConta, [
                Validators.required,
                Validators.maxLength(2)
            ]),
            outroCnpj: new FormControl(cedenteCnpjAlternativo.novoCnpj),
            cnpjRaiz: new FormControl(cedenteCnpjAlternativo.raiz),
            cnpjComplemento: new FormControl(cedenteCnpjAlternativo.complemento)
        });
    }

    updateParametros() {
        this.cedenteService
            .getParametros(
                this.currentUser.token.assignorGuid,
                this.currentUser.token.userReferenceId
            )
            .subscribe(response => {
                if (response.status === ApiError.Sucesso) {
                    // carregar parametros
                    this.parametrosDataService.setCurrentParametrosValue(
                        response.result
                    );
                }
            });
    }
    onItemSelect(item: any) {
        this.tipoChavePix = item.id;
        this.tipoChavePixDesc = item.description;
      }

    onSubmit(dadoBancarioCadastro: DadoBancarioCedenteCadastro) {
        if (this.dadoBancarioFormGroup.controls.outroCnpj.value){
            let cnpj = `${this.dadoBancarioFormGroup.controls.cnpjRaiz.value}/${this.dadoBancarioFormGroup.controls.cnpjComplemento.value}`;
            if (!this.validarCNPJ(cnpj)) {
                this.cnpjError = true;
            } else {
                this.cnpjError = false;
                dadoBancarioCadastro.cnpj = cnpj.replace(/[^\d]+/g,'');
            }
        } else {
            this.cnpjError = false
        }

        if (this.dadoBancarioFormGroup.valid && !this.cnpjError) {
            this.dadoBancarioService.add(dadoBancarioCadastro, this.currentUser.token.assignorGuid, this.currentUser.token.userReferenceId).subscribe(
                response => {
                    if (response.status === ApiError.Sucesso) {

                        this.alertService.success(response.message, true);
                        this.updateParametros();
                        this.parametrosDataService.loadNotifications();
                        if (this.urlReturn === null) {
                            this.router.navigate(['list'], { relativeTo: this.route.parent });
                        } else {
                            this.router.navigate([this.urlReturn]);
                        }

                    } else {
                        this.alertService.error(response.message);
                    }
                },
                error => {
                    console.log(error);
                    this.alertService.error('Ocorreu um erro ao buscar os dados!');
                }
            );
        } else {
            GenericValidator.verifierValidatorsForm(this.dadoBancarioFormGroup);
        }
    }
}
